import { contentTiles, tokenGeneration } from './content-tiles-de.i18n';

export const de = {
  contentTiles,
  tokenGeneration,
};
